// extracted by mini-css-extract-plugin
export var intro = "index-module--intro--C4dpM";
export var list = "index-module--list--+0B75";
export var listItem = "index-module--listItem--BubbZ";
export var listItemDescription = "index-module--listItemDescription--84dWA";
export var listItemLink = "index-module--listItemLink--Asns5";
export var textCenter = "index-module--textCenter--Ts42-";